import { FC } from 'react';

export const FormText: FC = ({ children }) => <small className="form-text text-muted d-block">{children}</small>;
